import { useEffect, useRef, useState } from "preact/hooks";
import { ui } from "./store.ts";

export function Chat({ onSend }: { onSend: (text: string, team: boolean) => void }) {
  const input = useRef<HTMLInputElement>(null);
  const [text, setText] = useState("");
  const [, tick] = useState(0);
  const open = ui.chatOpen.value;

  useEffect(() => {
    if (open) {
      document.exitPointerLock?.();
      setTimeout(() => input.current?.focus(), 0);
    }
  }, [open]);
  useEffect(() => {
    const iv = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(iv);
  }, []);

  const close = () => {
    ui.chatOpen.value = false;
    setText("");
  };
  const now = Date.now();
  return (
    <div class={`chat ${open ? "open" : ""}`} aria-live="polite">
      {ui.chat.value.slice(-8).map((l) => (
        <div key={l.id} class={`line ${l.system ? "sys" : ""} ${now - l.at > 9000 ? "old" : ""}`}>
          {l.from && <b>{l.from}: </b>}
          {l.text}
        </div>
      ))}
      {open && (
        <input
          ref={input}
          value={text}
          maxLength={200}
          placeholder="Say something — /help for commands, Esc to close"
          aria-label="Chat message"
          onInput={(e) => setText(e.currentTarget.value)}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === "Enter") {
              if (text.trim()) onSend(text.trim(), e.shiftKey);
              close();
              (document.querySelector("canvas.world") as HTMLCanvasElement)?.requestPointerLock?.();
            } else if (e.key === "Escape") close();
          }}
          onBlur={close}
        />
      )}
    </div>
  );
}
